import { useState } from 'react'
import { useEffect } from 'react'
import { DatePicker } from 'react-advance-jalaali-datepicker'
import { useForm } from 'react-hook-form'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

import Layout from "../../layouts/layout";
import MainPageLayout from '../../components/main-page-layout/mainPageLayout'
import { getSingleUser, updateSingleUsers } from '../../api/users'
import { useRequestProcessor } from '../../api/requestProcessor'
import Loading from '../../components/loading/loading'

const EditUser = () => {

    const { Query, Mutate } = useRequestProcessor();
    const navigate = useNavigate()

    const { mutate } = Mutate(
        "updateSingleUser",
        updateSingleUsers,
        {
            onSuccess: (data) => {
                toast.success(data.message)
                toast.info("تا چند ثانیه دیگر به صفحه اصلی منتقل میشوید", {
                    autoClose: 2500,
                    pauseOnHover: false
                })
                setTimeout(() => { navigate("/admin/users") }, 3000)
            }
        }

    )


    const { user_id } = useParams();
    const [isActive, setIsActive] = useState(true)


    const [ role, setRole ] = useState([
        {
            name: "admin",
            label: "ادمین"
        },
        {
            name: "user",
            label: "کاربر عادی"
        },
    ])

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();

    const { data: fetchedData, isLoading, isError } = Query(
        ['getSingleUser', user_id],
        () => getSingleUser(user_id)
    );


    async function onHookFormhandler(data) {
        const { lastname, name, phone, level, password, email } = data;
        let userData = {
            id: user_id,
            data: {
                name: name, lastname: lastname, phone: phone, level: level,
                password: password, email: email, active: isActive
            }
        }
        mutate(userData)
        // await updateSingleUser(params.user_id, { title: title, email: email, phone: phone, national_code: national_code })
        //     .then(res => res.status === "success" ? toast.success(res.message) : toast.error(res.error))
    }




    useEffect(() => {
        reset(fetchedData?.data);
        setIsActive(fetchedData?.data?.active)
    }, [fetchedData]);


    if(isLoading) return <Loading />
    return (    
        <Layout>
            <MainPageLayout title={"تصحیح مشخصات کاربر " + fetchedData?.data?.name} backButton sectionTitle={"تصحیح مشخصات کاربر"} >
                <form onSubmit={handleSubmit((data) => onHookFormhandler(data))} className='flex flex-col'>
                    <div className="flex wsm:flex-col">
                        <div className='flex-col my-4 !w-full'>
                            <div className='flex flex-col my-3'>
                                <p className={`pr-3 pb-1 ${errors.name && "text-red-500"}`}>نام :</p>
                                <input type="text" {...register("name", { required: true })} className='form-input !w-full' placeholder='نام' />
                            </div>
                            <div className='flex flex-col my-3'>
                                <p className={`pr-3 pb-1 ${errors.lastname && "text-red-500"}`}>نام خانوادگی:</p>
                                <input type="text" {...register("lastname", { required: true })} className='form-input !w-full' placeholder='نام خانوادگی ' />
                            </div>
                            <div className='flex flex-col my-3'>
                                <p className={`pr-3 pb-1 ${errors.email && "text-red-500"}`}>ایمیل :</p>
                                <input type="email" autoComplete="new-email" {...register("email")} className='form-input !w-full' placeholder='ایمیل' />
                            </div>
                            <div class="flex-col  w-full ">
                                <p>وضعیت کاربر :</p>
                                <div className="mx-10 items-center flex wsm:!mx-0 mt-2">
                                    <p>غیر فعال</p>
                                    <label class="relative inline-flex  cursor-pointer mx-2">
                                        <input type="checkbox" value={isActive} onChange={(e) => setIsActive(prev => !prev)} class="sr-only peer" />
                                        <div class={`w-11 h-6  rounded-full peer ${isActive ? "bg-sky-300" : "bg-gray-200"}  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all `}></div>
                                    </label>
                                    <p>فعال</p>
                                </div>
                            </div>
                        </div>
                        <div className="flex-col my-4 !w-full mr-2">
                            <div className='flex flex-col my-3'>
                                <p className={`pr-3 pb-1 ${errors.level && "text-red-500"}`}>نقش :</p>
                                <select {...register("level", { required: true })} className="!w-full  border border-gray-500 py-2 px-[20px] rounded-[10px] focus:border-[#1976d2bf]" >
                                    {
                                        role?.map(el => (
                                            <option key={el.id} className="py-3" value={el.name} >{el.label}</option>
                                        ))
                                    }
                                </select>
                            </div>
                            <div className='flex flex-col my-3'>
                                <p className={`pr-3 pb-1 ${errors.phone && "text-red-500"}`}>شماره تلفن:</p>
                                <input type="number" autoComplete="new-phone" {...register("phone", { required: true, minLength: 11, maxLength: 11 })} className='form-input !w-full' placeholder='شماره ' />
                            </div>
                            <div className='flex flex-col my-3'>
                                <p className={`pr-3 pb-1 ${errors.password && "text-red-500"}`}>پسورد :</p>
                                <input type="password" autoComplete="new-password" {...register("password")} className='form-input !w-full' placeholder='در صورت عدم تغییر, این فیلد را خالی بگذارید' />
                            </div>
                        </div>
                    </div>
                    <div id='form-add-button--container'>
                        <button type="submit" id='form-add-button'>ثبت</button>
                    </div>
                </form>
            </MainPageLayout>
        </Layout>
    )
}

export default EditUser